/** DEMO-ONLY: entered manufacturer part # / manufacturer SKU → catalog product id
 * (Quick Order / product resolve). Catalog id === manufacturerSKU for all products;
 * there is no separate Presidio SKU.
 */
export const PRESIDIO_MPN_TO_SKU: Record<string, string> = {
  '1250G': '1250g',
  '32UN880': '32UN880',
  '3R02047': '3R02047',
  '4001DN': '4001dn',
  '4301FDW': '4301fdw',
  '45-248-026': '45-248-026',
  '7000E': '7000E',
  '747': '747',
  '75UR640S': '75UR640S',
  'A7516': 'A7516',
  'AMD-MI300X': 'AMD-MI300X',
  'AMD-MI325X': 'AMD-MI325X',
  'AP8858': 'AP8858',
  'ATA191': 'ATA191',
  'BDL-AI-LAB': 'BDL-AI-LAB',
  'BDL-CLOUD': 'BDL-CLOUD',
  'BDL-EDGE': 'BDL-EDGE',
  'BDL-SEC': 'BDL-SEC',
  'BRIO-4K': 'BRIO-4K',
  'C210E': 'C210E',
  'C9200-48P': 'C9200-48P',
  'C9300L-48P': 'C9300L-48P',
  'C9400-CHASSIS': 'C9400-Chassis',
  'C9500-48Y4C': 'C9500-48Y4C',
  'CCS-720XP': 'CCS-720XP',
  'CISCO-C9300': 'CISCO-C9300',
  'CL-15': 'CL-15',
  'CP-8841': 'CP-8841',
  'CP-8865': 'CP-8865',
  'CS-KIT-MINI': 'CS-KIT-MINI',
  'CSF-3105': 'CSF-3105',
  'CT16G56C46S5': 'CT16G56C46S5',
  'CT8G4DFRA32': 'CT8G4DFRA32',
  'DCS-7050X3': 'DCS-7050X3',
  'DCS-7130': 'DCS-7130',
  'DCS-7280R3': 'DCS-7280R3',
  'DCS-7800R3': 'DCS-7800R3',
  'DDN-AI200': 'DDN-AI200',
  'DDN-AI400X2': 'DDN-AI400X2',
  'DDN-EXA9': 'DDN-EXA9',
  'DDN-IME': 'DDN-IME',
  'DDN-SFA18K': 'DDN-SFA18K',
  'DEF-UNI': 'DEF-UNI',
  'DELL-AI-STOR-60': 'DELL-AI-STOR-60',
  'DELL-ECS-EX300': 'DELL-ECS-EX300',
  'DELL-MX760C': 'DELL-MX760C',
  'DELL-PMAX2500': 'DELL-PMAX2500',
  'DELL-PSTORE500': 'DELL-PSTORE500',
  'DELL-R660': 'DELL-R660',
  'DELL-R750': 'DELL-R750',
  'DELL-R760XA': 'DELL-R760XA',
  'DELL-SC5020': 'DELL-SC5020',
  'DELL-T550': 'DELL-T550',
  'DELL-XE8640': 'DELL-XE8640',
  'DELL-XE9680': 'DELL-XE9680',
  'DELL-XR11': 'DELL-XR11',
  'DELL-XR4000': 'DELL-XR4000',
  'DS-1630': 'DS-1630',
  'E24-G5': 'E24-G5',
  'ED800-G9': 'ED800-G9',
  'EV2-85': 'EV2-85',
  'EX4400-48MP': 'EX4400-48MP',
  'EX4650-48Y': 'EX4650-48Y',
  'FAC-300F': 'FAC-300F',
  'FAZ-300F': 'FAZ-300F',
  'FG-100F': 'FG-100F',
  'FG-600F': 'FG-600F',
  'FI-8170': 'fi-8170',
  'FOCUS2': 'FOCUS2',
  'FPR-2130': 'FPR-2130',
  'FTNT-SASE-B': 'FTNT-SASE-B',
  'FW-86BZ30L': 'FW-86BZ30L',
  'GA04815': 'GA04815',
  'HPE-ALL-6050': 'HPE-ALL-6050',
  'HPE-C7000': 'HPE-C7000',
  'HPE-DL360-G11': 'HPE-DL360-G11',
  'HPE-DL380-PERF': 'HPE-DL380-PERF',
  'HPE-DL560-G11': 'HPE-DL560-G11',
  'HPE-EL8000': 'HPE-EL8000',
  'HPE-ML350-G11': 'HPE-ML350-G11',
  'HPE-NIM-HF20': 'HPE-NIM-HF20',
  'HPE-PRIM-A650': 'HPE-PRIM-A650',
  'HPE-RL300': 'HPE-RL300',
  'HPE-SO-3660': 'HPE-SO-3660',
  'IE-3400': 'IE-3400',
  'IFP4320': 'IFP4320',
  'IPHONE15-128': 'IPHONE15-128',
  'IPHONE15P-256': 'IPHONE15P-256',
  'ISE-3695': 'ISE-3695',
  'ISR4331-V': 'ISR4331-V',
  'J9772A': 'J9772A',
  'JL624A': 'JL624A',
  'JL661A': 'JL661A',
  'KSM56R46BD4': 'KSM56R46BD4',
  'LAT-5540': 'LAT-5540',
  'LAT-7440': 'LAT-7440',
  'LEN-SE450': 'LEN-SE450',
  'LEN-SE70': 'LEN-SE70',
  'LEN-SR630-V3': 'LEN-SR630-V3',
  'LEN-SR650-V3': 'LEN-SR650-V3',
  'LEN-SR850-V3': 'LEN-SR850-V3',
  'LSM1U': 'LSM1U',
  'LW-550': 'LW-550',
  'M321R4GA3BB0': 'M321R4GA3BB0',
  'M321R8GA0BB0': 'M321R8GA0BB0',
  'M800': 'M800',
  'MDM-KIT': 'MDM-KIT',
  'MFC-L5900DW': 'MFC-L5900DW',
  'MK2D3': 'MK2D3',
  'MW632ST': 'MW632ST',
  'MX-KEYS': 'MX-KEYS',
  'MX3S': 'MX3S',
  'MZ-V8P2T0': 'MZ-V8P2T0',
  'N9K-C9336C': 'N9K-C9336C',
  'N9K-C9364D': 'N9K-C9364D',
  'NTAP-A250': 'NTAP-A250',
  'NTAP-A400': 'NTAP-A400',
  'NTAP-A700': 'NTAP-A700',
  'NTAP-A800': 'NTAP-A800',
  'NTAP-CVO': 'NTAP-CVO',
  'NTAP-FAS2750': 'NTAP-FAS2750',
  'NTAP-ONTAP-AI': 'NTAP-ONTAP-AI',
  'NTAP-SG': 'NTAP-SG',
  'NV-6000-ADA': 'NV-6000-ADA',
  'NV-A40': 'NV-A40',
  'NV-A6000': 'NV-A6000',
  'NV-B100': 'NV-B100',
  'NV-DGX-A100': 'NV-DGX-A100',
  'NV-DGX-B200': 'NV-DGX-B200',
  'NV-DGX-GB200': 'NV-DGX-GB200',
  'NV-DGX-H100': 'NV-DGX-H100',
  'NV-DGX-STN': 'NV-DGX-STN',
  'NV-H100-PCIE': 'NV-H100-PCIE',
  'NV-H200-PCIE': 'NV-H200-PCIE',
  'NV-HGX-B200': 'NV-HGX-B200',
  'NV-HGX-H100': 'NV-HGX-H100',
  'NV-HGX-H200': 'NV-HGX-H200',
  'NV-L4-24G': 'NV-L4-24G',
  'NV-L40-48G': 'NV-L40-48G',
  'NV-L40S-24': 'NV-L40S-24',
  'NV-L40S-24-1U-3Y': 'NV-L40S-24-1U-3Y',
  'NV-L40S-24-1U-5Y': 'NV-L40S-24-1U-5Y',
  'NV-L40S-24-2U-3Y': 'NV-L40S-24-2U-3Y',
  'NV-L40S-24-2U-5Y': 'NV-L40S-24-2U-5Y',
  'NV-L40S-48': 'NV-L40S-48',
  'NV-L40S-48-1U-3Y': 'NV-L40S-48-1U-3Y',
  'NV-L40S-48-1U-5Y': 'NV-L40S-48-1U-5Y',
  'NV-L40S-48-2U-3Y': 'NV-L40S-48-2U-3Y',
  'NV-L40S-48-2U-5Y': 'NV-L40S-48-2U-5Y',
  'NV-L40S-48G': 'NV-L40S-48G',
  'NV-L40S-CFG': 'NV-L40S-CFG',
  'OPTI-7010': 'OPTI-7010',
  'PA-3220': 'PA-3220',
  'PA-5450': 'PA-5450',
  'PAN-M-100': 'PAN-M-100',
  'PAN-PRISMA-K': 'PAN-PRISMA-K',
  'PL-4K': 'PL-4K',
  'PRS-AI-STARTER': 'PRS-AI-STARTER',
  'PRS-AI-STARTER-BDL': 'PRS-AI-STARTER',
  'PRS-AI-STOR-60': 'DELL-AI-STOR-60',
  'PRS-AMD-MI300X': 'AMD-MI300X',
  'PRS-AMD-MI325X': 'AMD-MI325X',
  'PRS-API-SEC': 'PRS-API-SEC',
  'PRS-ARCH-1': 'PRS-ARCH-1',
  'PRS-ARCH-DISK': 'PRS-ARCH-DISK',
  'PRS-ARISTA-7050': 'DCS-7050X3',
  'PRS-ARISTA-7130': 'DCS-7130',
  'PRS-ARISTA-720XP': 'CCS-720XP',
  'PRS-ARISTA-7280': 'DCS-7280R3',
  'PRS-ARISTA-7800': 'DCS-7800R3',
  'PRS-BAG-15': 'CL-15',
  'PRS-BARCODE': '1250g',
  'PRS-BARE-1': 'PRS-BARE-1',
  'PRS-BAT-EXT': 'SMX120BP',
  'PRS-BDL-AI-LAB': 'BDL-AI-LAB',
  'PRS-BDL-CLOUD': 'BDL-CLOUD',
  'PRS-BDL-EDGE': 'BDL-EDGE',
  'PRS-BDL-SEC': 'BDL-SEC',
  'PRS-BIND-COMB': 'C210E',
  'PRS-BKP-100': 'PRS-BKP-100',
  'PRS-BLADE-C7000': 'HPE-C7000',
  'PRS-CBL-USB4': 'USB4-08',
  'PRS-CISCO-C9200': 'C9200-48P',
  'PRS-CISCO-C9300': 'CISCO-C9300',
  'PRS-CISCO-C9300L': 'C9300L-48P',
  'PRS-CISCO-C9400': 'C9400-Chassis',
  'PRS-CISCO-C9500': 'C9500-48Y4C',
  'PRS-CISCO-FTD': 'FPR-2130',
  'PRS-CISCO-IE': 'IE-3400',
  'PRS-CISCO-ISE': 'ISE-3695',
  'PRS-CISCO-N9K': 'N9K-C9336C',
  'PRS-CISCO-N9K-SP': 'N9K-C9364D',
  'PRS-CISCO-SEC': 'CSF-3105',
  'PRS-CISCO-UMBRELLA': 'UMB-SIG-KIT',
  'PRS-CLOUD-BARE': 'PRS-BARE-1',
  'PRS-CLOUD-CTRL': 'PRS-CTRL-3',
  'PRS-CLOUD-GPUW': 'PRS-GPU-W1',
  'PRS-CLOUD-HCI': 'PRS-HCI-3',
  'PRS-CLOUD-K8S': 'PRS-K8S-N1',
  'PRS-CORE-100': 'PRS-CORE-100',
  'PRS-CRYPT-GW': 'PRS-CRYPT-GW',
  'PRS-CTRL-3': 'PRS-CTRL-3',
  'PRS-DDN-AI200': 'DDN-AI200',
  'PRS-DDN-AI400': 'DDN-AI400X2',
  'PRS-DDN-EXA9': 'DDN-EXA9',
  'PRS-DDN-IME': 'DDN-IME',
  'PRS-DDN-SFA18K': 'DDN-SFA18K',
  'PRS-DELL-ECS': 'DELL-ECS-EX300',
  'PRS-DELL-MX760': 'DELL-MX760C',
  'PRS-DELL-PMAX': 'DELL-PMAX2500',
  'PRS-DELL-PSTORE': 'DELL-PSTORE500',
  'PRS-DELL-R660': 'DELL-R660',
  'PRS-DELL-R750': 'DELL-R750',
  'PRS-DELL-R760': 'PRS-DELL-R760',
  'PRS-DELL-R760XA': 'DELL-R760XA',
  'PRS-DELL-SC': 'DELL-SC5020',
  'PRS-DELL-XE8640': 'DELL-XE8640',
  'PRS-DELL-XE9680': 'DELL-XE9680',
  'PRS-DELL-XR11': 'DELL-XR11',
  'PRS-DELL-XR4000': 'DELL-XR4000',
  'PRS-DGX-A100': 'NV-DGX-A100',
  'PRS-DGX-B200': 'NV-DGX-B200',
  'PRS-DGX-GB200': 'NV-DGX-GB200',
  'PRS-DGX-H100': 'NV-DGX-H100',
  'PRS-DGX-STATION': 'NV-DGX-STN',
  'PRS-DNS-SEC': 'PRS-DNS-SEC',
  'PRS-DOCK-TB4': 'TS4',
  'PRS-DOCK-WD19': 'WD19S',
  'PRS-EDGE-AP': 'PRS-EDGE-AP',
  'PRS-EDGE-FW': 'PRS-EDGE-FW',
  'PRS-EDGE-IDS': 'PRS-IDS-1',
  'PRS-EDGE-INF': 'PRS-EDGE-INF',
  'PRS-EDGE-KIT': 'PRS-EDGE-KIT',
  'PRS-EDGE-MINI': 'PRS-EDGE-MINI',
  'PRS-EDGE-SW': 'PRS-EDGE-SW',
  'PRS-EDGE-VPN': 'PRS-VPN-C',
  'PRS-EDGE-WAF': 'PRS-WAF-1',
  'PRS-EMAIL-SEC': 'PRS-EMAIL-SEC',
  'PRS-FAB-KIT': 'PRS-FAB-KIT',
  'PRS-FC-KIT': 'PRS-FC-KIT',
  'PRS-FTNT-FAC': 'FAC-300F',
  'PRS-FTNT-FAZ': 'FAZ-300F',
  'PRS-FTNT-FG': 'PRS-FTNT-FG',
  'PRS-FTNT-FG100F': 'FG-100F',
  'PRS-FTNT-FG600F': 'FG-600F',
  'PRS-FTNT-FORTISASE': 'FTNT-SASE-B',
  'PRS-GAL-S24': 'SM-S921',
  'PRS-GAL-XCOVER': 'SM-G736',
  'PRS-GDS-1': 'PRS-GDS-1',
  'PRS-GPU-6000ADA': 'NV-6000-ADA',
  'PRS-GPU-A40': 'NV-A40',
  'PRS-GPU-A6000': 'NV-A6000',
  'PRS-GPU-B100': 'NV-B100',
  'PRS-GPU-H100-PCIE': 'NV-H100-PCIE',
  'PRS-GPU-H200-PCIE': 'NV-H200-PCIE',
  'PRS-GPU-L4': 'NV-L4-24G',
  'PRS-GPU-L40': 'NV-L40-48G',
  'PRS-GPU-L40S': 'NV-L40S-48G',
  'PRS-GPU-W1': 'PRS-GPU-W1',
  'PRS-HCI-3': 'PRS-HCI-3',
  'PRS-HGX-B200': 'NV-HGX-B200',
  'PRS-HGX-H100': 'NV-HGX-H100',
  'PRS-HGX-H200': 'NV-HGX-H200',
  'PRS-HP-ELITED': 'ED800-G9',
  'PRS-HP-ZBOOK': 'ZBOOK-F16',
  'PRS-HPE-2530': 'J9772A',
  'PRS-HPE-ALLETRA': 'HPE-ALL-6050',
  'PRS-HPE-CX10000': 'R8S96A',
  'PRS-HPE-CX6300': 'JL661A',
  'PRS-HPE-CX8325': 'JL624A',
  'PRS-HPE-DL360': 'HPE-DL360-G11',
  'PRS-HPE-DL380': 'PRS-HPE-DL380',
  'PRS-HPE-DL380P': 'HPE-DL380-PERF',
  'PRS-HPE-DL560': 'HPE-DL560-G11',
  'PRS-HPE-EDGELINE': 'HPE-EL8000',
  'PRS-HPE-NIMBLE': 'HPE-NIM-HF20',
  'PRS-HPE-PRIMERA': 'HPE-PRIM-A650',
  'PRS-HPE-RL300': 'HPE-RL300',
  'PRS-HPE-STOREONCE': 'HPE-SO-3660',
  'PRS-HUB-USB': 'A7516',
  'PRS-HYB-20': 'PRS-HYB-20',
  'PRS-HYB-80': 'PRS-HYB-80',
  'PRS-IDP-1': 'PRS-IDP-1',
  'PRS-IDS-1': 'PRS-IDS-1',
  'PRS-IND-8': 'PRS-IND-8',
  'PRS-INF-EDGE': 'PRS-EDGE-INF',
  'PRS-INF-RAG': 'PRS-RAG-1',
  'PRS-IPHONE-15': 'IPHONE15-128',
  'PRS-IPHONE-15P': 'IPHONE15P-256',
  'PRS-JUN-EX4400': 'EX4400-48MP',
  'PRS-JUN-EX4650': 'EX4650-48Y',
  'PRS-JUN-QFX10002': 'QFX10002-72Q',
  'PRS-JUN-QFX5120': 'QFX5120-48Y',
  'PRS-K8S-N1': 'PRS-K8S-N1',
  'PRS-KB-MECH': 'Q1',
  'PRS-KB-MXKEYS': 'MX-KEYS',
  'PRS-L40S-CFG': 'NV-L40S-CFG',
  'PRS-L40S-CFG-24': 'NV-L40S-24',
  'PRS-L40S-CFG-24-1U-3YR': 'NV-L40S-24-1U-3Y',
  'PRS-L40S-CFG-24-1U-5YR': 'NV-L40S-24-1U-5Y',
  'PRS-L40S-CFG-24-2U-3YR': 'NV-L40S-24-2U-3Y',
  'PRS-L40S-CFG-24-2U-5YR': 'NV-L40S-24-2U-5Y',
  'PRS-L40S-CFG-48': 'NV-L40S-48',
  'PRS-L40S-CFG-48-1U-3YR': 'NV-L40S-48-1U-3Y',
  'PRS-L40S-CFG-48-1U-5YR': 'NV-L40S-48-1U-5Y',
  'PRS-L40S-CFG-48-2U-3YR': 'NV-L40S-48-2U-3Y',
  'PRS-L40S-CFG-48-2U-5YR': 'NV-L40S-48-2U-5Y',
  'PRS-LAB-STOR': 'PRS-LAB-STOR',
  'PRS-LAB-STOR2': 'PRS-LAB-STOR2',
  'PRS-LABEL-DYMO': 'LW-550',
  'PRS-LAM-A3': 'SATURN3I',
  'PRS-LAT-5540': 'LAT-5540',
  'PRS-LAT-7440': 'LAT-7440',
  'PRS-LEAF-25': 'PRS-LEAF-25',
  'PRS-LEN-SE450': 'LEN-SE450',
  'PRS-LEN-SE70': 'LEN-SE70',
  'PRS-LEN-SR630': 'LEN-SR630-V3',
  'PRS-LEN-SR650': 'LEN-SR650-V3',
  'PRS-LEN-SR850': 'LEN-SR850-V3',
  'PRS-LEN-T14': 'T14-G5',
  'PRS-MDM-ENR': 'MDM-KIT',
  'PRS-META-1': 'PRS-META-1',
  'PRS-MG-24': 'PRS-MG-24',
  'PRS-MON-24FHD': 'E24-G5',
  'PRS-MON-27UHD': 'U2723QE',
  'PRS-MON-32UHD': '32UN880',
  'PRS-MON-34UW': 'S34C650',
  'PRS-MON-49UW': 'U4924DW',
  'PRS-MON-MOUNT': '45-248-026',
  'PRS-MOUSE-OPT': 'PRS-MOUSE-OPT',
  'PRS-MS-MX3': 'MX3S',
  'PRS-MSEG-1': 'PRS-MSEG-1',
  'PRS-NAC-1': 'PRS-NAC-1',
  'PRS-NAS-48': 'PRS-NAS-48',
  'PRS-NFS-GW': 'PRS-NFS-GW',
  'PRS-NTAP-A250': 'NTAP-A250',
  'PRS-NTAP-A400': 'NTAP-A400',
  'PRS-NTAP-A700': 'NTAP-A700',
  'PRS-NTAP-A800': 'NTAP-A800',
  'PRS-NTAP-CVO': 'NTAP-CVO',
  'PRS-NTAP-FAS': 'NTAP-FAS2750',
  'PRS-NTAP-ONTAP': 'NTAP-ONTAP-AI',
  'PRS-NTAP-SG': 'NTAP-SG',
  'PRS-NVME-100': 'PRS-NVME-100',
  'PRS-OBJ-200': 'PRS-OBJ-200',
  'PRS-OBJ-50': 'PRS-OBJ-50',
  'PRS-OMNI-WS': 'PRS-OMNI-WS',
  'PRS-OOB-24': 'PRS-OOB-24',
  'PRS-OPTI-7010': 'OPTI-7010',
  'PRS-OT-SEC': 'PRS-OT-SEC',
  'PRS-PAN-3220': 'PA-3220',
  'PRS-PAN-5450': 'PA-5450',
  'PRS-PAN-PANORAMA': 'PAN-M-100',
  'PRS-PAN-PRISMA': 'PAN-PRISMA-K',
  'PRS-PAPER-A4': '3R02047',
  'PRS-PDU-24': 'AP8858',
  'PRS-PDU-SW': 'PX3-5490V',
  'PRS-PHONE-CASE': 'DEF-UNI',
  'PRS-PIX-8': 'GA04815',
  'PRS-POE-48': 'PRS-POE-48',
  'PRS-PROJ-4K': 'PL-4K',
  'PRS-PROJ-WXGA': 'MW632ST',
  'PRS-PRT-CLR': '4301fdw',
  'PRS-PRT-LABEL': 'ZD421',
  'PRS-PRT-LJ400': '4001dn',
  'PRS-PRT-MFP': 'MFC-L5900DW',
  'PRS-PRT-PLOTTER': 'T630-24',
  'PRS-PSU-1600': 'PSU-1600T',
  'PRS-PURE-CBR': 'PURE-CBR',
  'PRS-PURE-CBS': 'PURE-CBS-LIC',
  'PRS-PURE-FAC': 'PURE-FAC',
  'PRS-PURE-FAX': 'PURE-FAX',
  'PRS-PURE-FAXL': 'PURE-FAXL',
  'PRS-PURE-FB': 'PURE-FB',
  'PRS-PURE-FBE': 'PURE-FBE',
  'PRS-PURE-FBX': 'PURE-FBX',
  'PRS-PURE-PORT': 'PURE-PX-ESS',
  'PRS-PURE-X20': 'PRS-PURE-X20',
  'PRS-RAG-1': 'PRS-RAG-1',
  'PRS-RAM-128KIT': 'KSM56R46BD4',
  'PRS-RAM-16DDR5': 'CT16G56C46S5',
  'PRS-RAM-32DDR5': 'M321R4GA3BB0',
  'PRS-RAM-64DDR5': 'M321R8GA0BB0',
  'PRS-RAM-8DDR4': 'CT8G4DFRA32',
  'PRS-REPL-1': 'PRS-REPL-1',
  'PRS-S3-GW': 'PRS-S3-GW',
  'PRS-SAN-ISCSI': 'PRS-SAN-ISCSI',
  'PRS-SASE-1': 'PRS-SASE-1',
  'PRS-SCAN-F1': 'fi-8170',
  'PRS-SCAN-FLAT': 'DS-1630',
  'PRS-SEC-API': 'PRS-API-SEC',
  'PRS-SEC-DNS': 'PRS-DNS-SEC',
  'PRS-SEC-EMAIL': 'PRS-EMAIL-SEC',
  'PRS-SEC-MICRO': 'PRS-MSEG-1',
  'PRS-SEC-NAC': 'PRS-NAC-1',
  'PRS-SEC-OT': 'PRS-OT-SEC',
  'PRS-SEC-SOC': 'PRS-SOC-SENS',
  'PRS-SHRED-16': 'PS-16C',
  'PRS-SIGNPAD': 'STU-540',
  'PRS-SMB-1': 'PRS-SMB-1',
  'PRS-SMCI-4U': 'SMCI-4U-SDS',
  'PRS-SMCI-4XL40S': 'SMCI-4L40S',
  'PRS-SMCI-8XH100': 'SMCI-HGX-8H100',
  'PRS-SMCI-EDGE': 'SMCI-EDGE-1',
  'PRS-SMCI-GPU1U': 'SMCI-1U-GPU',
  'PRS-SMCI-SYS2U': 'SMCI-221H',
  'PRS-SOC-SENS': 'PRS-SOC-SENS',
  'PRS-SPINE-400': 'PRS-SPINE-400',
  'PRS-SSD-2TNVM': 'MZ-V8P2T0',
  'PRS-STAPLER-HV': '747',
  'PRS-STOR-ARCH': 'PRS-ARCH-1',
  'PRS-STOR-ARCHIVE2': 'PRS-ARCH-DISK',
  'PRS-STOR-BKP': 'PRS-BKP-100',
  'PRS-STOR-CRYPT': 'PRS-CRYPT-GW',
  'PRS-STOR-FC': 'PRS-FC-KIT',
  'PRS-STOR-GPUDIR': 'PRS-GDS-1',
  'PRS-STOR-HYB20': 'PRS-HYB-20',
  'PRS-STOR-HYB80': 'PRS-HYB-80',
  'PRS-STOR-LAB': 'PRS-LAB-STOR',
  'PRS-STOR-LAB2': 'PRS-LAB-STOR2',
  'PRS-STOR-META': 'PRS-META-1',
  'PRS-STOR-NAS': 'PRS-NAS-48',
  'PRS-STOR-NFS': 'PRS-NFS-GW',
  'PRS-STOR-NVME': 'PRS-NVME-100',
  'PRS-STOR-OBJ-S3': 'PRS-S3-GW',
  'PRS-STOR-OBJ200': 'PRS-OBJ-200',
  'PRS-STOR-OBJ50': 'PRS-OBJ-50',
  'PRS-STOR-REPL': 'PRS-REPL-1',
  'PRS-STOR-SAN': 'PRS-SAN-ISCSI',
  'PRS-STOR-SMB': 'PRS-SMB-1',
  'PRS-STOR-TIER2': 'PRS-T2-BUF',
  'PRS-STOR-VEEAM': 'PRS-VEEAM-R',
  'PRS-STUDIO': 'PRS-STUDIO',
  'PRS-SUPPORT-3YR': 'SUPPORT-3YR',
  'PRS-SVC-AI-ASSESS': 'PRS-SVC-AI-ASSESS',
  'PRS-SVC-ARCH': 'SVC-ARCH',
  'PRS-SVC-AUTOM': 'SVC-IAC',
  'PRS-SVC-BACKUP': 'SVC-BKP-OPS',
  'PRS-SVC-CABLING': 'SVC-CABLE',
  'PRS-SVC-DEPLOY': 'PRS-SVC-DEPLOY',
  'PRS-SVC-DISC': 'SVC-DISC',
  'PRS-SVC-DR': 'SVC-DR',
  'PRS-SVC-FINOPS': 'SVC-FINOPS',
  'PRS-SVC-FW': 'SVC-FW',
  'PRS-SVC-GPUOPS': 'SVC-GPU-OPS',
  'PRS-SVC-HEALTH': 'SVC-HEALTH',
  'PRS-SVC-K8S': 'SVC-K8S',
  'PRS-SVC-MIG': 'SVC-MIG',
  'PRS-SVC-NET': 'SVC-NET',
  'PRS-SVC-NOC': 'SVC-NOC',
  'PRS-SVC-OPS': 'SVC-OPS-MO',
  'PRS-SVC-PATCH': 'SVC-PATCH',
  'PRS-SVC-RUN': 'SVC-HYPER',
  'PRS-SVC-SEC-ASS': 'SVC-SEC-A',
  'PRS-SVC-STAFF': 'SVC-FTE',
  'PRS-SVC-STOR': 'SVC-STOR',
  'PRS-SVC-TRAIN': 'SVC-TRAIN',
  'PRS-SVC-WLAN': 'SVC-WLAN',
  'PRS-SVC-ZT': 'SVC-ZT-DES',
  'PRS-SW-CORE1': 'PRS-CORE-100',
  'PRS-SW-FABRIC': 'PRS-FAB-KIT',
  'PRS-SW-IND': 'PRS-IND-8',
  'PRS-SW-LEAF': 'PRS-LEAF-25',
  'PRS-SW-MGBIT': 'PRS-MG-24',
  'PRS-SW-MGMT': 'PRS-OOB-24',
  'PRS-SW-POE': 'PRS-POE-48',
  'PRS-SW-SPINE': 'PRS-SPINE-400',
  'PRS-SW-WIFI-UP': 'PRS-WIFI-SW',
  'PRS-T2-BUF': 'PRS-T2-BUF',
  'PRS-TEL-8841': 'CP-8841',
  'PRS-TEL-8865': 'CP-8865',
  'PRS-TEL-ATA': 'ATA191',
  'PRS-TEL-GW': 'ISR4331-V',
  'PRS-TEL-J179': 'VVX-450',
  'PRS-TEL-SBC': 'M800',
  'PRS-TIMECLK': '7000E',
  'PRS-TONER-BK': 'W2020A',
  'PRS-TONER-CMY': 'W2021-23A',
  'PRS-TOWER-ML350': 'HPE-ML350-G11',
  'PRS-TOWER-T550': 'DELL-T550',
  'PRS-TRACKPAD': 'MK2D3',
  'PRS-TRN-POD': 'PRS-TRN-POD4',
  'PRS-TRN-POD4': 'PRS-TRN-POD4',
  'PRS-TV-43TOUCH': 'IFP4320',
  'PRS-TV-55LED': 'UN55CU7000',
  'PRS-TV-65QLED': 'QN65Q60C',
  'PRS-TV-75LED': '75UR640S',
  'PRS-TV-86LED': 'FW-86BZ30L',
  'PRS-TV-MOUNT': 'LSM1U',
  'PRS-UCC-BAR': 'STUDIO-X50',
  'PRS-UCC-CAM': 'RALLY-CAM',
  'PRS-UCC-HEAD': 'EV2-85',
  'PRS-UCC-HEAD2': 'FOCUS2',
  'PRS-UCC-ROOM': 'CS-KIT-MINI',
  'PRS-UCC-SPK': 'SPEAK750',
  'PRS-UCC-TEAMS': 'TR-STD',
  'PRS-UPS-1500': 'SMT1500',
  'PRS-UPS-3000': 'SMT3000',
  'PRS-VAST-AI': 'VAST-AI-STOR',
  'PRS-VAST-CBOX': 'VAST-CBOX',
  'PRS-VAST-DNODE': 'VAST-DNODE',
  'PRS-VAST-SNAP': 'VAST-SNAP',
  'PRS-VEEAM-R': 'PRS-VEEAM-R',
  'PRS-VPN-C': 'PRS-VPN-C',
  'PRS-WAF-1': 'PRS-WAF-1',
  'PRS-WEBCAM-4K': 'BRIO-4K',
  'PRS-WEKA-EDGE': 'WEKA-EDGE',
  'PRS-WEKA-FS': 'WEKA-NODE',
  'PRS-WEKA-SCALE': 'WEKA-SCALE',
  'PRS-WIFI-SW': 'PRS-WIFI-SW',
  'PRS-WS-OMNI': 'PRS-OMNI-WS',
  'PRS-WS-STUDIO': 'PRS-STUDIO',
  'PRS-ZT-IDP': 'PRS-IDP-1',
  'PRS-ZT-SASE': 'PRS-SASE-1',
  'PS-16C': 'PS-16C',
  'PSU-1600T': 'PSU-1600T',
  'PURE-CBR': 'PURE-CBR',
  'PURE-CBS-LIC': 'PURE-CBS-LIC',
  'PURE-FAC': 'PURE-FAC',
  'PURE-FAX': 'PURE-FAX',
  'PURE-FAXL': 'PURE-FAXL',
  'PURE-FB': 'PURE-FB',
  'PURE-FBE': 'PURE-FBE',
  'PURE-FBX': 'PURE-FBX',
  'PURE-PX-ESS': 'PURE-PX-ESS',
  'PX3-5490V': 'PX3-5490V',
  'Q1': 'Q1',
  'QFX10002-72Q': 'QFX10002-72Q',
  'QFX5120-48Y': 'QFX5120-48Y',
  'QN65Q60C': 'QN65Q60C',
  'R8S96A': 'R8S96A',
  'RALLY-CAM': 'RALLY-CAM',
  'S34C650': 'S34C650',
  'SATURN3I': 'SATURN3I',
  'SM-G736': 'SM-G736',
  'SM-S921': 'SM-S921',
  'SMCI-1U-GPU': 'SMCI-1U-GPU',
  'SMCI-221H': 'SMCI-221H',
  'SMCI-4L40S': 'SMCI-4L40S',
  'SMCI-4U-SDS': 'SMCI-4U-SDS',
  'SMCI-EDGE-1': 'SMCI-EDGE-1',
  'SMCI-HGX-8H100': 'SMCI-HGX-8H100',
  'SMT1500': 'SMT1500',
  'SMT3000': 'SMT3000',
  'SMX120BP': 'SMX120BP',
  'SPEAK750': 'SPEAK750',
  'STU-540': 'STU-540',
  'STUDIO-X50': 'STUDIO-X50',
  'SUPPORT-3YR': 'SUPPORT-3YR',
  'SVC-ARCH': 'SVC-ARCH',
  'SVC-BKP-OPS': 'SVC-BKP-OPS',
  'SVC-CABLE': 'SVC-CABLE',
  'SVC-DISC': 'SVC-DISC',
  'SVC-DR': 'SVC-DR',
  'SVC-FINOPS': 'SVC-FINOPS',
  'SVC-FTE': 'SVC-FTE',
  'SVC-FW': 'SVC-FW',
  'SVC-GPU-OPS': 'SVC-GPU-OPS',
  'SVC-HEALTH': 'SVC-HEALTH',
  'SVC-HYPER': 'SVC-HYPER',
  'SVC-IAC': 'SVC-IAC',
  'SVC-K8S': 'SVC-K8S',
  'SVC-MIG': 'SVC-MIG',
  'SVC-NET': 'SVC-NET',
  'SVC-NOC': 'SVC-NOC',
  'SVC-OPS-MO': 'SVC-OPS-MO',
  'SVC-PATCH': 'SVC-PATCH',
  'SVC-SEC-A': 'SVC-SEC-A',
  'SVC-STOR': 'SVC-STOR',
  'SVC-TRAIN': 'SVC-TRAIN',
  'SVC-WLAN': 'SVC-WLAN',
  'SVC-ZT-DES': 'SVC-ZT-DES',
  'T14-G5': 'T14-G5',
  'T630-24': 'T630-24',
  'TR-STD': 'TR-STD',
  'TS4': 'TS4',
  'U2723QE': 'U2723QE',
  'U4924DW': 'U4924DW',
  'UMB-SIG-KIT': 'UMB-SIG-KIT',
  'UN55CU7000': 'UN55CU7000',
  'USB4-08': 'USB4-08',
  'VAST-AI-STOR': 'VAST-AI-STOR',
  'VAST-CBOX': 'VAST-CBOX',
  'VAST-DNODE': 'VAST-DNODE',
  'VAST-SNAP': 'VAST-SNAP',
  'VVX-450': 'VVX-450',
  'W2020A': 'W2020A',
  'W2021-23A': 'W2021-23A',
  'WD19S': 'WD19S',
  'WEKA-EDGE': 'WEKA-EDGE',
  'WEKA-NODE': 'WEKA-NODE',
  'WEKA-SCALE': 'WEKA-SCALE',
  'ZBOOK-F16': 'ZBOOK-F16',
  'ZD421': 'ZD421',
};

export function resolvePresidioProductSku(entered: string | undefined | null): string {
  const key = (entered || '').trim().toUpperCase();
  if (!key) { return ''; }
  return PRESIDIO_MPN_TO_SKU[key] || (entered || "").trim();
}

/** Since Intershop sku === manufacturer SKU, return the catalog sku itself. */
export function manufacturerPartForSku(sku: string | undefined | null): string | undefined {
  const resolved = resolvePresidioProductSku(sku);
  return resolved || undefined;
}
